export var PageTypeEnum;
(function (PageTypeEnum) {
    PageTypeEnum["home_page"] = "home_page";
    PageTypeEnum["thank_you_page"] = "thank_you_page";
    PageTypeEnum["checkout_page"] = "checkout_page";
})(PageTypeEnum || (PageTypeEnum = {}));
